import takeWhile from 'lodash-es/takeWhile'

import {
  ADDRESS_POSTCODE_SEGMENT_PATTERN,
  ADDRESS_SEGMENT_SEPARATOR,
  ADDRESS_SEGMENT_SPLIT_PATTERN,
} from '../constants/address'

// The first segment is the street even if it starts with digits.
function getShortAddressSegments([street, ...segments]) {
  return [
    street,
    ...takeWhile(
      segments,
      segment => !ADDRESS_POSTCODE_SEGMENT_PATTERN.test(segment)
    ),
  ]
}

export function getShortAddress(address) {
  return address
    ? getShortAddressSegments(
        address.trim().split(ADDRESS_SEGMENT_SPLIT_PATTERN)
      ).join(ADDRESS_SEGMENT_SEPARATOR)
    : null
}
